/**
 * @typedef {Object} StoragePort
 * @property {(key: string) => string|null} getItem
 * @property {(key: string, value: string) => void} setItem
 * @property {(key: string) => void} removeItem
 */

/**
 * Wraps a runtime-provided browser storage implementation as raw string storage.
 *
 * @param {StoragePort} storage
 * @returns {StoragePort}
 */
export function createBrowserStoragePort(storage) {
  return {
    getItem: key => storage.getItem(key),
    setItem: (key, value) => storage.setItem(key, value),
    removeItem: key => storage.removeItem(key)
  }
}
